module.exports = __webpack_public_path__ + "static/media/money_icon.bc05cc52.png";